import FoodSafetyEquipmentHistoryScreen from './FoodSafetyEquipmentHistoryScreen'
import React from 'react'
import { useParams } from 'react-router-dom'
import {
  FOOD_SAFETY_ADHOC_SECTIONS,
  FOOD_SAFETY_SECTION,
} from 'src/constants/foodSafety'
import FoodSafetyAdHocSectionScreen from 'src/screens/food-safety/FoodSafetyAdHocSectionScreen'
import FoodSafetyCleaningScreen from 'src/screens/food-safety/FoodSafetyCleaningScreen'
import FoodSafetyFridgesScreen from 'src/screens/food-safety/FoodSafetyFridgesScreen'
import FoodSafetyProbeCalibrationScreen from 'src/screens/food-safety/FoodSafetyProbeCalibrationScreen'
import FoodSafetySectionPlaceholder from 'src/screens/food-safety/FoodSafetySectionPlaceholder'

/**
 * Section router — Fridges, ad-hoc, Cleaning; placeholder only as fallback.
 */
const FoodSafetySectionRoute = () => {
  const { section } = useParams()
  if (section === FOOD_SAFETY_SECTION.LEGACY_EQUIPMENT) {
    return <FoodSafetyEquipmentHistoryScreen />
  }
  if (section === FOOD_SAFETY_SECTION.FRIDGES_FREEZERS) {
    return <FoodSafetyFridgesScreen />
  }
  if (FOOD_SAFETY_ADHOC_SECTIONS.includes(section)) {
    // Keyed so Cooking → Cooling starts fresh instead of showing the previous
    // section's logs and draft while the new day loads.
    return <FoodSafetyAdHocSectionScreen key={section} section={section} />
  }
  if (section === FOOD_SAFETY_SECTION.CLEANING_CHECKLISTS) {
    return <FoodSafetyCleaningScreen />
  }
  if (
    [
      FOOD_SAFETY_SECTION.PROBE_CALIBRATION,
      FOOD_SAFETY_SECTION.DISHWASHERS,
    ].includes(section)
  ) {
    return <FoodSafetyProbeCalibrationScreen key={section} section={section} />
  }
  return <FoodSafetySectionPlaceholder />
}

export default FoodSafetySectionRoute
